import { useEffect, useState } from "react";
import CheckoutButton from "@/components/CheckoutButton";

export const StickyCta = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid="sticky-mobile-cta"
      className={`fixed bottom-0 inset-x-0 z-40 lg:hidden transition-transform duration-500 ${
        visible ? "translate-y-0" : "translate-y-full"
      }`}
    >
      <div className="glass-card border-t border-gold/25 bg-obsidian/92 px-4 py-3 flex items-center justify-between gap-3">
        <div className="min-w-0">
          <p className="text-xs text-slate-200 truncate">
            Business Assessment · <span className="text-gold font-bold">$99.99</span>
          </p>
          <p className="text-[10px] text-slate-500">7-Day Money-Back Guarantee</p>
        </div>
        <CheckoutButton
          lookup="aih_full_assessment"
          label="Get Started"
          testid="sticky-cta"
          className="shrink-0 rounded-full bg-gold text-obsidian font-display font-bold px-5 py-2.5 text-sm hover:bg-gold-bright transition-colors"
        />
      </div>
    </div>
  );
};

export default StickyCta;
